import { render, staticRenderFns } from "./ConfirmPickupDialog.vue?vue&type=template&id=624a7c1c&scoped=true"
import script from "./ConfirmPickupDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmPickupDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmPickupDialog.vue?vue&type=style&index=0&id=624a7c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624a7c1c",
  null
  
)

export default component.exports